<template>
  <Footer>
    <div class="footer">
      <div class="footer-contact">客服电话：<a :href="'tel:' + config.cfg_hotline">{{config.cfg_hotline}}</a></div>
      <div class="footer-copyright">{{config.cfg_copyright}}</div>
      <div class="footer-icp"><a href="http://www.beian.miit.gov.cn" target="_blank">{{config.cfg_icp}}</a></div>
    </div>
  </Footer>
</template>

<script>
export default {
  name: 'MobileFooter',
  props: {
    config: Object
  }
}
</script>

<style scoped lang="less">
  .footer{
    height: 240px;
    padding: 74px 0 70px;
    background-color: #434343;
    text-align: center;
    color: #ffffff;
  }
  .footer-contact{
    font-size: 24px;
    line-height: 36px;
    a{
      color: #ffffff;
    }
  }
  .footer-copyright{
    font-size: 16px;
    line-height: 28px;
  }
  .footer-icp{
    .footer-copyright;
    a{
      color: #ffffff;
    }
  }
  @media screen and (max-width: 1200px){
    .footer{
      height: 100px;
      padding: 27px 0 19px;
      background-color: #434343;
      text-align: center;
      color: #ffffff;
    }
    .footer-contact{
      margin-bottom: 4px;
      font-size: 16px;
      line-height: 18px;
    }
    .footer-copyright{
      font-size: 9px;
      line-height: 18px;
    }
    .footer-icp{
      .footer-copyright;
    }
  }
</style>
